module.exports = __webpack_public_path__ + "assets/img/face_check_example2.6e7fca0b.jpeg";